// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Alpine.js for lightweight UI interactions
import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()
